import { Container, Title, Text, Button, Stack } from '@mantine/core'
import { IconHome } from '@tabler/icons-react'
import { Link } from 'react-router-dom'
import { SEOHead } from '../components/SEOHead'
import { useI18n } from '@/hooks/useI18n'

export const NotFoundPage: React.FC = () => {
    const { t } = useI18n()

    return (
        <>
            <SEOHead
                title={t('notFound.title')}
                description="The page you're looking for doesn't exist. Browse our game collection to find the best video game deals and prices."
                canonicalUrl="https://spellen.land/404"
                type="website"
                noindex={true}
            />

            <Container size="sm" py="xl">
                <Stack align="center" gap="xl" ta="center">
                    <div>
                        <Title size="6rem" fw={900} c="blue" mb="md">
                            404
                        </Title>
                        <Title order={2} mb="md">
                            {t('notFound.title')}
                        </Title>
                        <Text c="dimmed" size="lg" mb="xl">
                            {t('notFound.description')}
                        </Text>
                    </div>

                    <Button
                        component={Link}
                        to="/"
                        variant="filled"
                        size="lg"
                        leftSection={<IconHome size={20} />}
                    >
                        {t('notFound.backHome')}
                    </Button>
                </Stack>
            </Container>
        </>
    )
} 